<template>
  <div class="hello">
    <Top/>
    <div style="width: 100%;background-color: #fff;margin: 10px auto;border-radius: 3px;">
      <div v-if="this.id == 1" style="height: 300px">
        <div id="contentT">临港建设</div>
<!--        <div class="time">-->
<!--          发布时间：<div id="contentTime"></div>-->
<!--        </div>-->
        <div id="concent">
          <p style="text-align: center">
            <img src="../assets/one.jpeg">
          </p>
          <div style="width: 1200px;margin: auto">
            扬州市临港建设发展有限公司成立于2012-02-03，法定代表人为傅延生，注册资本为144880万元人民币，统一社会信用代码为91321091589972995Y，企业地址位于维扬路28号，所属行业为房屋建筑业，经营范围包含：建设工程施工、监理、设计、咨询;市政公用工程施工总承包;园林绿化景观工程施工;城市建设投资与管理;城市土地开发与管理;钢结构施工;实业投资;国内贸易（建筑材料）。（依法须经批准的项目,经相关部门批准后方可开展经营活动）。扬州市临港建设发展有限公司目前的经营状态为存续（在营、开业、在册）。
          </div>

        </div>
      </div>
      <div v-if="this.id == 2" style="height: 300px">
        <div id="contentT">绿建公司</div>
        <!--        <div class="time">-->
        <!--          发布时间：<div id="contentTime"></div>-->
        <!--        </div>-->
        <div id="concent">
          <p style="text-align: center">
            <img src="../assets/two.jpeg">
          </p>
          <div style="width: 1200px;margin: auto">
            扬州绿投建设工程有限公司成立于2020-05-21，法定代表人为聂世强，注册资本为50000万元人民币，统一社会信用代码为91321091MA21J4JL97，企业地址位于扬州市开发区八里镇金山路123号1幢，所属行业为房屋建筑业，经营范围包含：许可项目:各类工程建设活动;电力设施承装、承修、承试;房屋建筑和市政基础设施项目工程总承包;建筑劳务分包;施工专业作业（依法须经批准的项目,经相关部门批准后方可开展经营活动,具体经营项目以审批结果为准）一般项目:园林绿化工程施工;土石方工程施工;对外承包工程（除依法须经批准的项目外,凭营业执照依法自主开展经营活动）。扬州绿投建设工程有限公司目前的经营状态为存续（在营、开业、在册）。
          </div>
        </div>
      </div>
      <div v-if="this.id == 3" style="height: 300px">
        <div id="contentT">智谷建设</div>
        <!--        <div class="time">-->
        <!--          发布时间：<div id="contentTime"></div>-->
        <!--        </div>-->
        <div id="concent">
          <p style="text-align: center">
            <img src="../assets/three.jpeg">
          </p>
          <div style="width: 1200px;margin: auto">
            扬州智谷建设发展有限公司成立于2016-06-28，法定代表人为丁振宇，注册资本为50000万元人民币，统一社会信用代码为91321091MA1MNTF680，企业地址位于扬州市经济开发区维扬路108号，所属行业为土木工程建筑业，经营范围包含：建设工程施工、监理、设计、咨询;城市建设与管理;城市土地开发与管理;房地产开发、经营。（依法须经批准的项目,经相关部门批准后方可开展经营活动##）一般项目:建筑用钢筋产品销售;金属材料销售;建筑材料销售;礼品花卉销售;树木种植经营（除依法须经批准的项目外,凭营业执照依法自主开展经营活动）。扬州智谷建设发展有限公司目前的经营状态为存续（在营、开业、在册）。
          </div>
        </div>
      </div>
      <div v-if="this.id == 4" style="height: 300px">
        <div id="contentT">希捷贸易</div>
        <!--        <div class="time">-->
        <!--          发布时间：<div id="contentTime"></div>-->
        <!--        </div>-->
        <div id="concent">
          <p style="text-align: center">
            <img src="../assets/four.jpeg">
          </p>
          <div style="width: 1200px;margin: auto">
            扬州希捷科技有限公司成立于2010-08-31，法定代表人为王广东，注册资本为8000万元人民币，统一社会信用代码为91321091561771390B，企业地址位于维扬路108号开发大厦附楼，所属行业为研究和试验发展，经营范围包含：一般项目:工程和技术研究和试验发展;电线、电缆经营;五金产品批发;五金产品零售;金属材料销售;金属制品销售;再生资源销售;纸浆销售;水泥制品销售;石棉水泥制品制造;电工仪器仪表销售;仪器仪表销售;电工器材销售;非金属矿及制品销售;煤炭及制品销售;再生资源回收（除生产性废旧金属）;电子元器件制造;电子元器件批发;电子元器件零售;进出口代理;食品进出口;新能源汽车整车销售;小微型客车租赁经营服务;技术进出口;生产性废旧金属回收;花卉种植;货物进出口;建筑材料销售;建筑防水卷材产品销售;建筑用钢筋产品销售;电子产品销售;机械设备销售;特种设备销售;机械电气设备销售;建筑装饰材料销售;涂料销售（不含危险化学品）;汽车新车销售;普通货物仓储服务（不含危险化学品等需许可审批的项目）;金属结构销售;包装材料及制品销售;包装服务;物料搬运装备销售;树木种植经营（除依法须经批准的项目外,凭营业执照依法自主开展经营活动）。扬州希捷科技有限公司目前的经营状态为存续（在营、开业、在册）。
          </div>
        </div>
      </div>
      <div v-if="this.id == 5" style="height: 600px">
        <div id="contentT">都市良田</div>
        <!--        <div class="time">-->
        <!--          发布时间：<div id="contentTime"></div>-->
        <!--        </div>-->
        <div id="concent">
          <p style="text-align: center">
            <img src="../assets/five.jpeg">
          </p>
          <div style="width: 1200px;margin: auto">
            扬州市都市良田农业发展有限公司成立于2021-03-23，法定代表人为范合情，注册资本为2000万元人民币，统一社会信用代码为91321091MA25GX563U，企业地址位于扬州市经济开发区维扬路108号开发大厦403室，所属行业为农、林、牧、渔专业及辅助性活动，经营范围包含：一般项目:农村民间工艺及制品、休闲农业和乡村旅游资源的开发经营;农业专业及辅助性活动;智能农业管理;灌溉服务;农林牧渔业废弃物综合利用;农作物秸秆处理及加工利用服务;农业机械租赁;农村集体经济组织管理;园区管理服务;集贸市场管理服务;休闲观光活动;技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广;土地整治服务;土壤污染治理与修复服务;树木种植经营;园林绿化工程施工;城市绿化管理;城市公园管理;初级农产品收购;园艺产品种植;供应链管理服务;防洪除涝设施管理;水利相关咨询服务;农业生产托管服务;商业综合体管理服务;土石方工程施工;创业投资（限投资未上市企业）;农业园艺服务;农作物栽培服务;农作物收割服务;水生植物种植;食用农产品零售;食用农产品批发;食用农产品初加工;非食用农产品初加工;农业科学研究和试验发展（除依法须经批准的项目外,凭营业执照依法自主开展经营活动）。扬州市都市良田农业发展有限公司目前的经营状态为存续（在营、开业、在册）。
          </div>
        </div>
      </div>
    </div>
    <FooterHtm/>
  </div>
</template>

<script>
import FooterHtm from './FooterHtm'
import Top from './Top'
export default {
  name: "firm",
  components:{
    Top,
    FooterHtm
  },
  data(){
    return {
      id:this.$route.query.id
    }
  },
  mounted() {
    console.log(this.id)
  }
}
</script>

<style scoped>
#contentT{
  border-bottom: 1px dashed gray;
  line-height: 48px;
  font-family: "Microsoft YaHei";
  font-size: 30px;
  text-align: center;
  color: #0d726e;
}
.time{
  display: flex;
  font-size: 18px;
  justify-content: center;
  color: grey;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 25px;
  line-height: 25px
}
#concent{
  text-align: center;
  margin: auto;
  font-size: 16px;
  /*margin-left: 15px;margin-right: 15px*/
}
</style>



// WEBPACK FOOTER //
// src/components/firm.vue